import { Grid, Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import styled from 'styled-components';

import { Styling, Colors } from '../../../constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  width: 100%;
  flex-grow: 1;
  height: calc(100% - 2px); 
`; // Weird issue with scroll bar appearing

// /////// Header /////////
export const StyledHeader = styled(Grid)`
  justify-content: space-between;
`;

export const OrgSelect = styled(Grid)`
  display: flex;
  justify-content: center;
  .accountIcon {
    margin-top: 20px;
    margin-right: 5px;
  }
  .formControl {
    min-width: 120px;
  }
`;

export const DateSelect = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 8px;
  h3 {
    margin: 8px 12px 8px 0px; 
  }
`;
// /////// Overview /////////
export const StyledOverview = styled(Grid)`
  justify-content: space-around;
  padding: 20px 0;
`;

export const OverviewCard = styled(Paper)`
  text-align: left;
  padding: 30px 0;
  height: 100%;
  h3 {
    color: ${Colors.BLACK_30};
    position: relative;
    top: -20px;
    left: 10px;
    font-size: 20px;
  }
  h1 {
    position: relative;
    left: ${Styling.DEFAULT_SPACING_DOUBLED}px;
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 80px;
    font-weight: bolder;
  }
`;

// /////// Table /////////
export const StyledTable = styled(Grid)`
  justify-content: flex-start;
  min-height: 325px;
  border-bottom: 1px solid ${Colors.BLACK_30};
`;

export const StyledDataGrid = styled(DataGrid)`
  width: 100%;
`;

// /////// Graph /////////
export const StyledGraph = styled(Grid)`
  justify-content: space-around;
  canvas {
    width: 100% !important;
    align-self: flex-end;
  }
`;

export const ProgressContainer = styled.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;
